import { useState, useEffect } from "react";
import clsx from 'clsx'
import { useIntl } from 'react-intl';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { IParametro } from "../../interfaces/IParametro";
import Swal from 'sweetalert2';
import ParametrizacaoTabela from "./ParametrizacaoTabela";
import ParametrizacaoService from "../../services/ParametrizacaoService";
import { Link, useHistory } from "react-router-dom";

const Parametrizacao = () => {

    const intl = useIntl();
    const [parametros, setParametros] = useState<IParametro[]>([]);
    const [paginaCarregada, setPaginaCarregada] = useState<boolean>(false);
    const [filtro, setFiltro] = useState<string>('');
    const { classes } = useLayout();
    const history = useHistory();
    const columns = [
      {
        name: 'Nome do Parâmetro',
        selector: (row: IParametro) => row['nome'],
        sortable: true
      },
      {
        name: 'Ações',
        cell: (row: IParametro) => <AcoesEventos excluirParametro={excluirParametro} editarParametro={(parametro: IParametro) => history.push("/parametrizacoes/editar/" + parametro.id)} item={row} />
      }
    ];

    useEffect(() => {
      async function preCarregar() {
        setPaginaCarregada(false);
        await ParametrizacaoService.obterTodos(x => setParametros(x));
        setPaginaCarregada(true);
      }

      setTimeout(() => {
        preCarregar();
      }, 1000)
    }, []);

    function AcoesEventos({ item, excluirParametro, editarParametro }: { item: IParametro, excluirParametro: (parametro: IParametro) => void, editarParametro: (Parametro: IParametro) => void }) {
        return <div data-tag="allowRowEvents">
            <i onClick={() => editarParametro(item)} className="fas fa-edit fs-1" style={{ color: '#5E6397', fontWeight: 'normal', cursor: 'pointer' }}/>
            <i onClick={() => excluirParametro(item)} className="fas fa-trash-alt fs-1" style={{ color: '#5E6397', marginLeft: '20px', fontWeight: 'normal', cursor: 'pointer' }}/>
        </div>
    }

    async function excluirParametro(parametro: IParametro) {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-modal-excluir ms-5',
                cancelButton: 'btn btn-modal-cancelar'
            },
            buttonsStyling: false
        });
        const result = await swalWithBootstrapButtons.fire({
            title: 'Excluir Parâmetro',
            text: `Você realmente deseja excluir esse Parâmetro?`,
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: `Excluir`,
            reverseButtons: true
        });

        if (result.isConfirmed) {
            await ParametrizacaoService.excluir(parametro?.id ?? 0, () => setParametros(parametros.filter(e => e.id !== parametro.id)), 'Parâmetro excluída com sucesso');
        }
    }

    return <>
        <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.PARAMETERIZATION' })}</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
                <input onChange={(e) => setFiltro(e.target.value)} placeholder="Buscar..." className="form-control" style={{ width: '50%' }} />
                <div className='d-flex align-items-center py-1'>

                    <Link to="/parametrizacoes/novo">
                        <button className='btn btn-sm btn-primario'>
                            <i className="icon-lg text-white fas fa-plus"></i>
                            <span style={{ verticalAlign: 'middle' }}> PARÂMETRO </span>
                        </button>
                    </Link>


                </div>
            </div>
        </div>

        { paginaCarregada ? <ParametrizacaoTabela filtro={filtro} colunas={columns} itens={parametros} /> : <p>Carregando...</p> }
    </>
};

export default Parametrizacao;